import { Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { useNavigation } from 'app/hooks/navigation';
import { Trans } from 'react-i18next';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconBellZ } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

const theme = createDSTheme();

export const UnavailableButton = function UnavailableButton() {
  const navigation = useNavigation();
  const onPress = () => navigation.navigate('unavailable', undefined, { pop: true });
  return (
    <Button
      onPress={onPress}
      marginTop="spacing.general.x8"
      testID="profile-unavailable-button"
      variant="secondaryLight"
    >
      <Row alignItems="center" gap="spacing.general.x2">
        <IconBellZ strokeWidth={ICON_STROKE_WIDTH} size={24} color={theme.colors['icon.primary']} />
        <Text fontSize={16} textAlign="center" variant="bodyBase">
          <Trans
            components={{ strong: <Text fontWeight="700" /> }}
            i18nKey="unavailableButtonLabel"
            ns="profile-overview"
          />
        </Text>
      </Row>
    </Button>
  );
};
